<template>
	<div class="container overx_auto">
		<div class="flex flex_items flex_center" style="min-width:1200px">
			<!-- <div class="bg-box">
				<img src="@/assets/login/login1.png" style="width:100%;height:620px;display:block">
			</div> -->
			<div class="content-page flex" style="height:620px">
				<div class="content-box">
					<div class="font2">安得儿童乐园窗口售票系统</div>
					<div class="ser-box bgfff">
						<!-- <div class="flex ser mb24" v-if="handle != 3">
							<div class="pointer" :class="handle == 2 ? 'bgfff' : 'c9'" @click="handle = 2">账号登录</div>
							<div class="pointer" :class="handle == 1 ? 'bgfff' : 'c9'" @click="handle = 1">手机号登录</div>
						</div> -->
						<div>
							<!-- 账号登录 -->
							<template v-if="handle == 2">
								<div class="input-box">
									<div class="input-box-left"></div>
									<div class="input-box-right">
										<input type="text" v-model="username" placeholder="请输入账号" maxlength="11" />
									</div>
								</div>
								<div class="input-box" style="margin-bottom:25px">
									<div class="input-box-left"></div>
									<div class="input-box-right">
										<input type="password" placeholder="请输入密码" v-model="password" />
									</div>
								</div>
							</template>
							<!-- 手机号登录 -->
							<template v-if="handle == 1">
								<div class="input-box">
									<div class="input-box-left"></div>
									<div class="input-box-right">
										<input type="text" v-model="mobile" placeholder="请输入手机号码" maxlength="11" />
									</div>
								</div>
								<div class="input-box">
									<div class="input-box-left"></div>
									<div class="input-box-right">
										<input type="text" placeholder="请输入验证码" v-model="code" />
									</div>
									<div class="get-code main_color pointer" @click="get_code" v-show="count == 60">
										获取验证码
									</div>
									<div class="get-code count" v-show="count < 60">{{ count }}秒重试</div>
								</div>
							</template>
							<div class="flex flex_between" v-if="handle == 2">
								<div class="c6 flex flex_items pointer" style="font-size:16px" v-if="handle == 2" >
									<el-checkbox v-model="remb">记住我</el-checkbox>
								</div>
								<!-- <div class="c8 f14" @click="handle == 1">忘记密码？</div> -->
							</div>
							<div style="margin-bottom:48px">
								<div class="login-btn pointer page_main_bg" @click="login" v-if="handle != 3">登录</div>
								<div style="color:red" class="txt_center mt10" v-if="!showWxLogin">该微信未绑定账号，请继续登录以绑定微信</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
// import {
// 	HERF,ewmStyleBase64
// } from "@/utils/tool";
// import { getItem } from '@/utils/storage'
import { setToken, setUserMsg, getToken } from "@/utils/auth"
import { loginNextPageShow } from "@/utils/tool";
import { Message } from "element-ui";
import pageRouter from '@/utils/pageMainSlider'
import {getQueryString} from "@/utils/index"
import { removeToken } from "../../utils/auth";

export default {
	name: "",
	props: {},
	data() {
		return {
			mobile: "",
			code: "",
			count: 60,
			check: false,
			handle: 2, //1-手机号登录 2-账号登录 3-微信登录
			username: '', //001
			password: '', //111111
			remb: true,//记住我
			appid: '',
			showWxLogin: true,
			loading: null,
		};
	},
	watch: {
		handle(e) {
			if (e == 3) {
				this.get_wx_qrcode();//获取微信登录二维码
			} else {
				if (this.$JQ('iframe')) {
					this.$JQ('iframe').remove()
				}
			}
		}
	},
	mounted() {},
	created() {
		// if(localStorage.getItem('token')){
		//   this.getUser()
		// }
		//http://192.168.3.8:8080/#/login?code=ck001

		// this.getUser()
		console.log(getQueryString('code'));
		
		if(getQueryString('code')){
			localStorage.setItem('code',getQueryString('code'))
		}else{
			this.$message.error('连接错误')
		}
		if(getToken()){
			this.pageGo()
		}
	},
	methods: {
		jzw(){
			this.remb = !this.remb;
			this.$forceUpdate()
		},
		get_wx_qrcode() {
			this.$nextTick(() => {
				var obj = new WxLogin({
					self_redirect: false,  //值为true时，直接在二维码的弹窗中进行页面跳转及其余操作,
					id: "login_container",       //需要承载二维码的容器id  
					appid: this.appid,
					scope: "snsapi_login",     //网页授权，目前网页只有这一种方式，静默授权
					redirect_uri: encodeURIComponent(this.HERF + 'h5/#/loginSuccess'),     //回调域名(地址前部分是项目域名，后部分loginSuccess是微信需要跳转的路径（vue中的路由名称）)
					state: Math.random(),
					style: "white",
					href: ewmStyleBase64
				});
			})
		},
		wechatConfig() {
			this.api.wechatConfig({ islogin: false }).then(res => {
				this.appid = res.data.appid
			})
		},
		changeType(type) {
			this.handle = type
		},
		getQueryString(str, variable) {
			let herf = str;
			let num = herf.indexOf("?") + 1;
			let query = herf.substring(num);
			let vars = query.split("&");
			for (let i = 0; i < vars.length; i++) {
				let pair = vars[i].split("=");
				if (pair[0] == variable) {
					return pair[1];
				}
			}
			return false;
		},
		login() {
			//1-手机号登录 2-账号登录 3-微信登录
			if (this.handle == 1) {
				this.phoneLogin()
			} else {
				this.usernameLogin()
			}
		},
		phoneLogin() {
			if (!this.mobile) {
				return this.$message.error("手机号不能为空");
			}
			if (!this.code) {
				return this.$message.error("验证码不能为空");
			}
			this.api.loginByPhone({
				phone: this.mobile,
				code: this.code,
			})
				.then((res) => {
					let obj = {
						name: 'token',
						value: res.data.api_token,
					}
					if (!this.remb) {
						obj.expires = 24 * 60 * 60 * 1000
						obj.startTime = new Date().getTime()
					}
					this.$storage.setItem(obj)
					this.$storage.setItem({
						name: 'user',
						value: res.data,
					})
					// this.$store.dispatch('app/setUser',JSON.stringify(res.data))
					if (res.code == 200) {
						this.pageGo(res)
					}
				}, (res) => {
					console.log(res);
					// if(res.data.code == )
				});
		},
		usernameLogin() {
			if(!getQueryString('code')){
				this.$message.error('连接错误')
				return
			}
			// console.log(getQueryString('code'),'3333');
			if (!this.username) {
				return this.$message.error("账号不能为空");
			}
			if (!this.password) {
				return this.$message.error("密码不能为空");
			}
			this.loading = this.$loading({
				lock: true,
				background: 'rgba(0, 0, 0, 0.08)'
			});
			this.$store.dispatch('app/setRoles', [])
			this.api.login({
				name: this.username,
				password: this.password,
			}, { loading: true })
				.then((res) => {
					let obj = {
						name: 'token',
						value: res.api_token,
					}
					if (!this.remb) {
						obj.expires = 24 * 60 * 60 * 1000
						obj.startTime = new Date().getTime()
					}
					this.$storage.setItem(obj)
					this.$message.success('登录成功')
					// this.$storage.setItem({
					// 	name: 'user',
					// 	value: res.data,
					// })
					// this.$store.dispatch('app/setUser',JSON.stringify(res.data))
					this.pageGo(res)
				}, () => {
					this.loading.close();
				});
		},
		pageGo(res) {
			if(res){
				setToken(res.api_token);
			}
			this.api.getUser().then(res1 => {
				this.$store.dispatch('app/setIslogin',1);
				setUserMsg(JSON.stringify(res1))
				this.api.config().then(res => {
					this.$store.dispatch('app/setRoles', res);
					if(this.loading){
						this.loading.close();
					}
					let filteredItems = pageRouter.filter(item =>
						item.role.some(role => res.includes(role))|| item.role.length == 0
					);
					this.$store.dispatch('app/setRouter', filteredItems);
					setTimeout(() => {
						this.$router.push(filteredItems[0].path)
					}, 800);
					// }
				}, () => {
					this.loading.close();
				})
			}, () => {
				this.loading.close();
				removeToken()
				this.$store.dispatch('app/setIslogin',0);
			})
		},
		// 获取验证码
		get_code() {
			if (!this.mobile) {
				return this.$message.error('手机号不能为空')
			}
			this.api.getCode({
				phone: this.mobile,
			})
				.then((res) => {
					if (res.data) {
						this.code = res.data
					}
					this.$message.success('发送成功')
					this.count -= 1;
					let a = setInterval(() => {
						this.count -= 1;
						if (this.count == 1) {
							this.count = 60;
							clearInterval(a);
						}
					}, 1000);
				});
		},
		oninputmobile() {
			if (!/^1[34578]\d{9}$/.test(this.mobile)) {
				this.$message.error("手机号码有误，请重填");
			}
		},

		gotoLien() {
			this.api.user().then((res) => { //获取用户手机号
				let obj = {};
				if (JSON.parse(localStorage.getItem("user"))) {
					obj = {
						...JSON.parse(localStorage.getItem("user")),
						...res.data,
					};
				} else {
					obj = res.data;
				}
				localStorage.setItem("user", JSON.stringify(obj));
				localStorage.removeItem("fromKey");
			});
		},
	},
};
</script>
<style lang="scss" scoped>
.container {
	min-width: 100%;
	height: 100vh;
	background: url('../../assets/login/login-background.png') center center no-repeat;
	background-size: cover;
	overflow-x: auto;
	box-sizing: border-box;
	display: flex;
	align-items: center;
	justify-content: center;
}

.content {
	height: 620px;
	width: 1670px;
	min-width: 1670px;
}

.content-box {
	padding: 112px 68px 0 68px;
	width: 100%;
}

.bg-box {
	flex: 1;
	background-size: cover;
	box-sizing: border-box;
	width: 110px;
}

.content-page {
	background: #fff;
	width: 560px;
	height: 100%;
	box-sizing: border-box;
}

.font1 {
	font-size: 30px;
	margin-bottom: 18px;
}

.font2 {
	font-size: 26px;
	color: #606266;
	margin-bottom: 42px;
}

.logo {
	width: 204px;
	margin: 0 auto;
	margin-bottom: 20px;
	// border-radius: 50%;
	// background-color: #4fd9d5;
}

.ser-box {
	border-radius: 5px;
	box-sizing: border-box;
}

.ser {
	width: 174px;
	height: 40px;
	background: #F8F9FF;
	border: 2px solid #F8F9FF;
	box-sizing: border-box;
	border-radius: 6px 6px 6px 6px;
}

.check {
	width: 16px;
	height: 16px;
	margin-right: 8px;
}

.ser>div {
	width: 50%;
	box-sizing: border-box;
	text-align: center;
	position: relative;
	height: 100%;
	display: flex;
	align-items: center;
	font-size: 15px;
	justify-content: center;
	border-radius: 6px 6px 6px 6px;
	color: #909399;
}

.ser>div.bgfff {
	color: #606266;
	box-shadow: 0px 0px 6px 1px rgba(196, 215, 233, 0.5);
}

.ser>div:last-child {
	width: 95px;
	margin-left: 8px;
}

.ser>div.page_main_color::after {
	position: absolute;
	width: 48px;
	height: 3px;
	border-radius: 2px;
	content: " ";
	bottom: -8px;
	left: 50%;
	transform: translateX(-50%);
	background: #44B035;
}

.input-box {
	margin-bottom: 32px;
	height: 48px;
	background: #F8F9FF;
	border: 1px solid #EEEEEE;
	border-radius: 4px;
	box-sizing: border-box;
	display: flex;
	align-items: center;
	overflow: hidden;

	.input-box-left {
		padding: 0 11px 0 16px;
		display: flex;
		align-items: center;
		justify-content: center;

		img {
			width: 15px;
			height: 17px;
		}
	}

	.input-box-right {
		flex: 1;
		width: 100%;
		height: 100%;

		input {
			width: 100%;
			height: 100%;
			border: none;
			background-color: transparent;
			font-size: 15px;
		}
	}

	.get-code {
		width: 95px;
		font-size: 16px;
		display: flex;
		align-items: center;
		justify-content: flex-start;
	}
}

.login-btn {
	height: 48px;
	width: 100%;
	border-radius: 5px;
	font-size: 18px;
	color: #ffffff;
	display: flex;
	font-weight: bold;
	align-items: center;
	justify-content: center;
	margin-top: 58px;
}

.linner {
	width: 90px;
	height: 1px;
	background: #CCCCCC;
}

.wx {
	width: 50px;
	margin: 0 auto;
}

.count {
	color: #999999 !important;
}

.ewm {
	width: 241px;
	height: 241px;
}

.s-icon {
	width: 48px;
	margin-bottom: 12px;
}

img {
	flex-shrink: 0;
}

input::placeholder {
	color: #ccc;
}
</style>
